module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', [(_vm.item.subquest_list) ? _c('div', _vm._l((_vm.item.subquest_list), function(subItem) {
    return _c('QuestionItem', {
      ref: "sub",
      refInFor: true,
      attrs: {
        "item": subItem
      }
    })
  })) : _c('div', [(_vm.isInput(_vm.item)) ? _c('QuestionTypeInput', {
    ref: "sub",
    attrs: {
      "item": _vm.item
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSelect(_vm.item)) ? _c('QuestionTypeSelect', {
    ref: "sub",
    attrs: {
      "item": _vm.item
    }
  }) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f2be48ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QuestionItem.vue
// module id = 270
// module chunks = 1